import { render, staticRenderFns } from "./Fin.vue?vue&type=template&id=5ca01db7&scoped=true&lang=html&"
import script from "./Fin.vue?vue&type=script&lang=js&"
export * from "./Fin.vue?vue&type=script&lang=js&"
import style0 from "./Fin.vue?vue&type=style&index=0&id=5ca01db7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca01db7",
  null
  
)

export default component.exports